import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Row, Form, Button } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { PDFInputFile } from "../../PDFFileHandler";
import { emptyValueObjects } from "../../../utils/ManageArray";
import TableForm from "../../TableForm";
import ConfirmModal from "../../ConfirmModal";
import SearchFilter from "../../SearchFilter";

const TicketNumberForm = ({ editData, onSubmitCallback }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [showModal, setShowModal] = useState({ CT: false, CF: false });
  const [validated, setValidated] = useState(false);
  const defaultData = { Com_Code: user.Com_Code };
  const [data, setData] = useState({ Array: [defaultData] });
  const columns = [
    { name: "Customer.Cus_Code", label: "รหัสสาขา" },
    { name: "Customer.Cus_NumBranch", label: "เลขที่สาขา" },
    { name: "Customer.Cus_Name", label: "ชื่อสาขา", size: 3 },
    { name: "PM_Of_Work", label: "PM/ครั้งที่" },
    { name: "Order_No", label: "เลขที่ใบสั่งงาน" },
    {
      name: "Ticket_No",
      label: "หมายเลขงานลูกค้า (Ticket No.)",
      size: 3
    }
  ];
  const searchInput = [
    {
      name: "Pm_No",
      label: "วันที่สร้างใบสั่งงานจากวันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date"
    },
    {
      name: "Pm_Of_Work",
      label: "ถึงวันที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "date"
    },
    {
      name: "Contract_No",
      label: "PM/ครั้งที่",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: "1_5",
      noneAsync: true,
      options: []
    },
    {
      name: "Contract_Start_Date",
      label: "เลขที่ใบสั่งงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      size: "7_5",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_Code",
      label: "รหัสสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: []
    },
    {
      name: "Cus_NumBranch",
      label: "เลขที่สาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: "1_5"
    },
    {
      name: "Cus_Name",
      label: "ชื่อสาขา",
      classNames: { col: "mb-3", label: "mb-1" },
      type: "select",
      noneAsync: true,
      options: [],
      size: 6
    }
  ];

  const serviceRequest = (serviceMethod, setDataResponse) => {
    setLoading(true);
    serviceMethod
      .then((response) => setDataResponse(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const checkValidity = () => {
    if (emptyValueObjects(data.Array, ["Part_File"]).length > 0) {
      showAlert({
        error: "ข้อผิดพลาด",
        message: "กรุณากรอกข้อมูลให้ครบถ้วน",
        type: "danger"
      });
      return false;
    }
    return true;
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity() || !checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal((prev) => ({ ...prev, CF: !showModal.CF }));
    }
  };

  const handleSubmit = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal((prev) => ({ ...prev, CF: showCallback }));

    if (dataCallback) {
      if (!editData) onSubmitCallback(dataCallback);
      else onSubmitCallback(dataCallback.Array[0]);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-center">
            นำเข้าหมายเลขงานลูกค้า(Ticket No.)
          </Card.Title>
        </Card.Header>

        <Card.Body>
          <SearchFilter
            data={data.Array}
            inputField={searchInput}
            fieldClassName={{
              inputRow: "justify-content-center",
              actionButton: "text-end",
              actionRowSize: "10_5"
            }}
            searchCallback={(search) => setSearchValue(search)}
          />
        </Card.Body>
      </Card>

      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดหมายเลขงานลูกค้า (Ticket No.)
            </Card.Title>

            <Form.Group>
              <PDFInputFile
                button={{
                  name: "นำออกฟอร์ม Ticket",
                  className: "me-3 px-4 py-2 rounded-pill",
                  color: "success"
                }}
              />
              <PDFInputFile
                button={{
                  name: "นำเข้าไฟล์ Ticket",
                  className: "px-4 py-2 text-dark rounded-pill",
                  color: "outline-secondary"
                }}
              />
            </Form.Group>
          </Card.Header>

          <Card.Body>
            <TableForm
              editForm
              data={data.Array}
              columns={columns}
              defaultData={defaultData}
              onChangeCallback={(newData) => setData({ Array: newData })}
            />
          </Card.Body>

          <Card.Footer className="p-3 text-end border-top-0 bg-transparent">
            <Button
              type="submit"
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill"
            >
              {editData ? "บันทึกการแก้ไข" : "บันทึกข้อมูล"}
            </Button>
            <ConfirmModal
              show={showModal.CF}
              data={data}
              content={editData ? "edit" : "save"}
              onSubmitCallback={handleSubmit}
            />

            <Button
              variant="outline-secondary"
              className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
              onClick={() => navigate("/PM_work/create", { state })}
            >
              ยกเลิก
            </Button>
          </Card.Footer>
        </Card>
      </Form>
    </>
  );
};

TicketNumberForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallback: PropTypes.func
};

export default TicketNumberForm;
